<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Mp2Pau/tc-custom/9781429909334.jpg?1720280501797" alt="This image is the cover for the book Cop's Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cop's Life
      </h1>
      <p class="bookDescription body article font2">
        <p>After September 11, 2001 Las Vegas Police Sergeant Randy Sutton began soliciting writing from law enforcement officers-his goal being to bridge the gap between the police and those they serve, with a book that offers a broad and thoughtful look at the many facets of police life.  Hundreds of active and former officers responded from all over the United States: men and women from big cities and small towns, some who had written professionally, but most for the first time. Sutton culled the selections into five categories: The Beat, Line of Duty, War Stories, Officer Down, and Ground Zero. <br/><br/>The result is <i>True Blue</i>, a collection of funny, charming, exciting, haunting stories about murder investigations, missing children, bungling burglars, car chases, lonely and desperate shut-ins, routine traffic stops, officers killed in the line of duty, and the life-changing events of September 11.  Here, officers reveal their emotions-fear and pride, joy and disgust, shame and love-as they recount the defining moments of their careers.  In these stories, the heart and soul behind the badge shines through in unexpected ways. <i>True Blue</i> will change the way we think about the deeply human realm of police service.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Randy Sutton
      </h2>
      
      <p class="authorDescription body article"><P><B>Randy Sutton</B> is a Senior Sergeant at the Las Vegas Metropolitan Police Department, Nevada. A member of the Screen Actors Guild, he has appeared in several big screen movies and HBO movies including <I>Casino</I>, <I>Fools Rush In</I>, and <I>The Road Home</I>. On television, he has appeared on <I>COPS</I>, <I>Americas Most Wanted</I>, and <I>Las Vegas</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?535b7886